module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.36b24548.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-light-webfont.eot
// module id = 266
// module chunks = 0